
import { NavLink,Routes,Route, Outlet } from 'react-router-dom';
import UsersList from './UsersList/UsersList';

const Dashboard = () => {
    return ( 
        <div className="container">
            <h2>Dashboard</h2>

            <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <div className="container-fluid">                    
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse show" id="navbarNavAltMarkup">
                    <div className="navbar-nav">
                        <NavLink to="/dashboard/users"  className={(navData) => navData.isActive ? "nav-link active" : "nav-link " } >Users</NavLink>
                        <NavLink to="/dashboard/events"  className={(navData) => navData.isActive ? " nav-link  active" : "nav-link " } >Events</NavLink>                                            
                    </div>
                    </div>
                </div>
            </nav>

            <div><Outlet/></div>

        </div>   
     );
}
 
export default Dashboard;